module.exports = __webpack_public_path__ + "static/orange-drawing-90f514b125b07392dfdde54c50b07b10.jpg";